<template>
  <transition>
    <div class="achievement-notificator" v-if="active">
      <h3 class="title">アチーブメント達成！</h3>
      <strong>〜{{title}}〜</strong>
      <p>{{body}}</p>

      <div class="actions">
        <span v-on:click="close" class="close">OK</span>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'Tutorial',
  data() {
    return {
      active: false,
      title: null,
      body: null,
    };
  },
  computed: {
    achievements() {
      return this.$store.state.game.achievements;
    },
  },
  methods: {
    close() {
      this.active = false;
      this.$store.dispatch('restartGame');
    },
  },
  watch: {
    achievements(achievements) {
      const achievement = achievements[achievements.length - 1];
      this.$store.dispatch('stopGame');
      this.active = true;
      this.title = achievement.title;
      this.body = achievement.body;
    },
  },
};
</script>

<style scoped lang="scss">
.v-enter-active,
.v-leave-active {
  transition: opacity 0.5s;
}

.v-enter,
.v-leave-to {
  opacity: 0;
}

.achievement-notificator {
  height: 200px;
  padding: 30px;
  color: #fff;
  background: rgba(0, 0, 0, 0.9);
  border-radius: 6px;
  box-shadow: 0 0 2px 1px rgba(0, 0, 0, 0.2);

  p {
    line-height: 1.6em;
  }

  .actions {
    position: absolute;
    bottom: 30px;
    left: 0;
    right: 0;
    margin: 0;
    width: 100%;
    height: 50px;
    text-align: center;

    .close {
      display: inline-block;
      width: 200px;
      padding: 1rem;
      border-radius: 3px;
      background: #0a5;
      color: #fff;
      font-weight: bold;
      font-size: 0.9rem;
      cursor: pointer;
      transition: opacity 0.2s ease;

      &:hover {
        opacity: 0.8;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/game/AchievementNotificator.vue